import React from "react"
import { Icon } from "@fider/components"
import { getCategory } from "@fider/services/khcn"
import { CATEGORY_ICONS } from "./categoryIcons"

// Tùy biến KHCN: ảnh đại diện thay thế khi bài không có ảnh — gradient theo màu hạng mục,
// hoa văn vòng tròn / đường nối kiểu mạng lưới và icon hạng mục ở giữa.
export const CategoryArt = ({ slug }: { slug?: string }) => {
  const category = slug ? getCategory(slug) : undefined
  const color = category ? `#${category.color}` : "#1d6fe8"
  const icon = slug ? CATEGORY_ICONS[slug] : undefined

  return (
    <div className="kh-art" style={{ background: `linear-gradient(135deg, ${color} 0%, ${color}cc 55%, #0a2e7a 100%)` }} aria-hidden="true">
      <svg className="kh-art__pattern" viewBox="0 0 200 200" preserveAspectRatio="xMidYMid slice" fill="none" stroke="#ffffff" strokeWidth="1.2">
        <circle cx="160" cy="40" r="46" />
        <circle cx="160" cy="40" r="70" strokeDasharray="4 6" />
        <circle cx="30" cy="170" r="40" />
        <path d="M0 140 L60 100 L110 130 L170 80 L200 95" />
        <path d="M0 175 L50 150 L95 172 L150 120 L200 140" strokeDasharray="3 5" />
        <circle cx="60" cy="100" r="3" fill="#ffffff" />
        <circle cx="110" cy="130" r="3" fill="#ffffff" />
        <circle cx="170" cy="80" r="3" fill="#ffffff" />
      </svg>
      {icon && (
        <span className="kh-art__icon">
          <Icon sprite={icon} />
        </span>
      )}
    </div>
  )
}
